<template>
    <div class="clinic">
        <studySearch ref="studySearch"  
        :hotwordList="hotwordList" 
        :sourceType="'studyDetails'"
        @searchClick="getList(1)"></studySearch>
        <div class="clinic-cont">
            <div class="cont-tit">{{ (titList.find(item => item.type == subType) || {}).val }}</div>
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb"> 
                <el-breadcrumb-item>{{firstClassification?firstClassification:'全部'}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{secondClassification?secondClassification:'' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <ul class="clinic-list">
                <li  v-for="(item,index) in listInfo" :key="index">
                    <a :href="item.url" target="_blank">
                         
                        <div class="list-info">
                            <div class="info-tit">{{ item.title }}</div>
                            <div class="info">
                                <!-- <div v-if='item.source'>
                                    <p class="info-label">来源：</p>
                                    <p class="info-value">{{item.source}}</p>
                                </div> -->
                                <div v-if='item.publishTime'>
                                    <p class="info-label">发布时间：</p>
                                    <p class="info-value">{{item.publishTime}}</p>
                                </div> 
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
            <div class="no-data" v-if="listInfo.length==0">暂无数据～</div>
            <el-pagination
                v-if="pageInfo.total!=0"
                @current-change="changePage" 
                :current-page="pageInfo.pageNum" 
                :page-count="pageInfo.pageTotal" 
                :page-size="pageInfo.pageSize" 
                :total="pageInfo.total"
                background
                layout="total, prev, pager, next" >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import studySearch from './comps/study_search.vue'

import { secondList,searchListTK } from '../../io/api';
export default {
    components:{
        studySearch
    },
    data () {
        return {
            searchVal:this.$route.query.searchWord||'',
            subType:this.$route.query.subType||1,
            firstClassification:this.$route.query.firstClassification||'',
            secondClassification:this.$route.query.secondClassification||'',
            titList:[ 
                { val: '临床指南', type: '1' },
                { val: '名医经验', type: '2' }, 
                { val: '方剂医案', type: '3' },
                { val: '中药课堂', type: '4' },
                { val: '常用中成药', type: '5' },
            ],
            hotwordList: [
                { val: '2型糖尿病' },
                { val: '失眠' },
                { val: '李佃贵' },
                { val: '百合固金汤' },
                { val: '大定风珠' },
            ],
            listInfo:[ ], 
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
        }
    },
    mounted(){
        this.getList(1) 
    },
    methods: {  
        getList(num){
            this.searchVal=this.$store.state.study.searchVal;
            let params={
                page: num?num:this.pageInfo.pageNum,
                limit: 10,
                type:this.subType<3?1:2,//1 学古籍 2 学临床
                keyWord:this.searchVal,
                subType:this.subType,
                firstClassification:this.firstClassification,
                secondClassification:this.secondClassification,
            };
            
            secondList(params).then(res=>{
                let {code,data,msg}=res.data;
                if(code==0){
                    if(data.list ){
                        this.listInfo = [].concat(data.list);
                        this.pageInfo.total=data.total||0;
                    }else{
                        if(this.searchVal==''){
                            window.open(data,'_self');
                            return;
                        } 
                    }
                }else{
                    this.$message.error(msg||'请求失败～');
                }
            })
        },
        changePage(num){
            this.pageInfo.pageNum=num;
            this.getList(num);
        },
        //banner检索
        banner_search(val){ 
            this.searchVal=val;
            this.getList(1);
            // this.getTree();
        }, 
        toPage(item){    
            let url= this.$router.resolve({
                path:'/studyDetails',  
                query:{

                },
            }) 
            this.$windowOpen({ url:url.href,isLogin:true} )
        },
 
    }
}
</script>

<style lang="less" scoped>
.clinic{ 
    .clinic-cont{
        width: 1200px;
        margin: 40px auto;
        ::v-deep .el-breadcrumb{
            margin-bottom: 30px;
            font-size: 16px;  
            font-weight: bold;
            .el-breadcrumb__inner{
                color: #386DE8;
            } 
        }
        .cont-tit{
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #303133;
            text-align: center;
        }
    }
    .tit{
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 30px;
    } 
    .clinic-list{
        li{
            display: flex;
            padding-bottom: 20px;
            border-bottom: 1px solid #C0D9F6;
            margin-bottom: 20px;  
            // &:hover{
            //     background: #EAF1FF;
            //     box-shadow: 0px 2px 4px 0px rgba(22,93,255,0.04);
            // }
            .list-pic{
                width: 240px;
                height: 140px;
                margin-right: 20px;
                border-radius: 6px;
                overflow: hidden;
            }
            .list-info{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 20px 0;
                // flex-direction: column;
                // justify-content: center;
                .info-tit{
                    font-size: 16px;
                    font-weight: bold; 
                    cursor: pointer;
                    &:hover{
                        color: #000;
                    }
                }
                .info{
                    display: flex;  
                    >div{
                        display: flex;
                        align-items: center;
                        margin-right:20px ;
                    }
                }
            }
        }

    }
    .no-data{
        text-align: center;
        font-size: 16px;

        padding:80px 0 120px;
    }
}
</style>